import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-subscribe-message',
  templateUrl: './subscribe-message.component.html',
  styleUrls: ['./subscribe-message.component.scss'],
})
export class SubscribeMessageComponent {
  constructor(private modalService: NgbModal) {}

  continueClick() {
    import('../../../../../components/modals/plan-modal/plan-modal-component.module').then(
      ({ PlanModalComponentModule }) => {
        const PlanModalComponent = PlanModalComponentModule.getComponent();
        this.modalService.open(PlanModalComponent, {
          backdrop: 'static',
          keyboard: false,
        });
      },
    );
  }
}
